import React, { FC } from "react";
import Dialog, { DialogProps } from "rc-dialog";
import "./index.scss";

const Modal: FC<DialogProps> = ({ ...props }) => {
  return <Dialog destroyOnClose={true} animation={"zoom"} {...props} />;
};

export default Modal;
